export var Name = 'show-loyalty-dialog';
export var ShowLoyaltyDialogEvent = Name;